import { createContext } from "react";

const OverlayContext = createContext();

export default OverlayContext;
